<script>
/**
 * Theme wrapper around vue-multiselect.
 * Renders selected values as removable tags for both single and multiple
 * modes so CSS can park chips below a stable single-line control.
 */
import Multiselect from 'vue-multiselect'

export default {
    name: 'SipSelect',
    extends: Multiselect,
    computed: {
        visibleValues() {
            return this.internalValue.slice(0, this.limit)
        }
    }
}
</script>
